/* eslint-disable @typescript-eslint/no-unused-vars */
import { getUserIdList } from '../../../api';
import { CustomPopover } from '../../../components/custom-popover';
import { CommonDotStatus, DotType } from '../../../components/tag';
import { isSupportSystem } from '../../../config';
import {
  getFirstManageSite,
  getLocalTime,
  getNeedManageSites,
  getSiteText,
  isMultiManageSite,
} from '../../../lib';
import { wrapRequestArea } from '../../../lib/http/lib';
import getFormatMessage from '../../../locales/get-format-message';
import {
  CommonStatusStep,
  IAPIUserInfo,
  IUserListItem,
} from '../../../model/api-modules';

const allSiteUserMap: Record<string, Record<string, IUserListItem>> = {};
let isFetched = false;
export const initAllSiteUsers = async () => {
  if (isFetched) {
    return;
  }
  isFetched = true;
  getNeedManageSites().map(async (site) => {
    const res = await wrapRequestArea(getUserIdList, site);
    const userMap: Record<string, IUserListItem> = res.reduce<
      Record<string, IUserListItem>
    >((acc, user) => {
      acc[user.id] = user;
      return acc;
    }, {});
    allSiteUserMap[site] = userMap;
  });
};

export const getUserNameByEmail = (email?: string, site?: string) => {
  if (!email) {
    return '';
  }

  if (isSupportSystem()) {
    return email.split('@')[0];
  }

  const userMap = allSiteUserMap[site || getFirstManageSite()];

  return (
    Object.values(userMap).find((item) => item.UserID === email)?.UserName ||
    email.split('@')?.[0] ||
    'System'
  );
};

export const getUserEmailBySite = (userId?: number | string, site?: string) => {
  if (!userId) {
    return 'System';
  }

  if (typeof userId === 'string' && userId.indexOf('@') !== -1) {
    return userId;
  }
  if (
    isNaN(Number(userId)) &&
    typeof userId === 'string' &&
    userId.indexOf('@') === -1
  ) {
    return `${userId}@tencent.com`;
  }
  const userMap = allSiteUserMap[site || getFirstManageSite()];

  return userMap[userId]?.UserID || String(userId) || 'System';
};

export const getUserNameBySite = (userId?: number | string, site?: string) => {
  if (!userId) {
    return 'System';
  }

  if (typeof userId === 'string' && userId.indexOf('@') !== -1) {
    return getUserNameByEmail(userId, site);
  }
  const userMap = allSiteUserMap[site || getFirstManageSite()];
  if (isNaN(Number(userId)) && typeof userId === 'string') {
    return userId;
  }
  if (isSupportSystem()) {
    return userMap[userId]?.UserID.split('@')[0];
  }
  return userMap[userId]?.UserID || String(userId) || 'System';
};

export const getAntLastModifyColumn = (
  options = {},
  userInfo: IAPIUserInfo | null,
  site?: string
) => {
  return {
    title: getFormatMessage('last_modify_time_local'),
    key: 'ModifyTime',
    dataIndex: 'ModifyTime',
    render: (_text: string, record: any) => {
      return (
        <div>
          <div>
            {getLocalTime(record.ModifyTime, userInfo?.UserSettings?.Timezone)}
          </div>
          <div>
            {getUserNameBySite(
              record.LastModifiedUserId ||
                record.ModifierUserID ||
                record.LastUpdaterID ||
                record.ModifierID ||
                record.CreatorID ||
                record.FounderID,
              site
            )}
          </div>
        </div>
      );
    },
    ...options,
  };
};

export const getValidateStatusText = (status: CommonStatusStep) => {
  const map = {
    [CommonStatusStep.Pending]: '未启用',
    [CommonStatusStep.Resolve]: '启用中',
    [CommonStatusStep.Reject]: getFormatMessage('common_status_step_expired'),
  };

  return map[status];
};

export const renderValidateStatusDot = (
  status: CommonStatusStep,
  customText = ''
) => {
  const statsDotMap: Record<CommonStatusStep, DotType> = {
    [CommonStatusStep.Pending]: 'gray',
    [CommonStatusStep.Reject]: 'gray',
    [CommonStatusStep.Resolve]: 'green',
  };
  return (
    <CommonDotStatus type={statsDotMap[status]}>
      {customText || getValidateStatusText(status)}
    </CommonDotStatus>
  );
};

export const renderOpenStatusDot = (opened: boolean) => {
  return (
    <CommonDotStatus type={opened ? 'green' : 'gray'}>
      {opened ? '开启' : '关闭'}
    </CommonDotStatus>
  );
};

export const renderPartlyValidateStatusDot = () => {
  return (
    <CommonDotStatus type={'yellow'}>
      {getFormatMessage('common_status_step_partly')}
    </CommonDotStatus>
  );
};

export const renderValidateStatusCell = (
  statusMap: Record<string, CommonStatusStep>,
  whiteMap: Record<string, boolean> = {}
) => {
  if (!isMultiManageSite()) {
    if (whiteMap[getFirstManageSite()]) {
      return renderPartlyValidateStatusDot();
    }
    const status = statusMap[getFirstManageSite()];
    return renderValidateStatusDot(status);
  }

  const multiStatus = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
      }}
    >
      {getNeedManageSites().map((site) => {
        const siteStatus = statusMap[site];
        if (siteStatus === CommonStatusStep.Resolve && whiteMap[site]) {
          return (
            <>
              <div>
                {getSiteText(site)}：{renderPartlyValidateStatusDot()}
              </div>
            </>
          );
        }
        return (
          <>
            <div>
              {getSiteText(site)}：{renderValidateStatusDot(siteStatus)}
            </div>
          </>
        );
      })}
    </div>
  );

  return <CustomPopover content={multiStatus}>{multiStatus}</CustomPopover>;
};
